import { createTheme } from "@mui/material/styles";
import { AUTH_COLORS, AUTH_FONT } from "./authConstants";

/**
 * MUI theme for HR Admin + Super Admin.
 * Matches joinee/auth tokens. Do not change workflows here.
 */
export var ADMIN_THEME = createTheme({
  palette: {
    primary: {
      main: AUTH_COLORS.primary,
      dark: AUTH_COLORS.primaryHover,
      contrastText: AUTH_COLORS.buttonLabel,
    },
    secondary: {
      main: "#050A44",
      contrastText: AUTH_COLORS.buttonLabel,
    },
    error: {
      main: AUTH_COLORS.error,
    },
    text: {
      primary: AUTH_COLORS.text,
      secondary: AUTH_COLORS.textSecondary,
    },
    divider: AUTH_COLORS.borderSecondary,
    background: {
      default: "#F1F2F4",
      paper: AUTH_COLORS.surface,
    },
    grey: {
      100: "#F1F2F4",
      200: AUTH_COLORS.borderSecondary,
    },
  },
  typography: {
    fontFamily: AUTH_FONT,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    button: {
      textTransform: "none",
      fontWeight: 400,
      fontFamily: AUTH_FONT,
    },
    body1: { fontFamily: AUTH_FONT, fontWeight: 400 },
    body2: { fontFamily: AUTH_FONT, fontWeight: 400 },
    h6: { fontFamily: AUTH_FONT, fontWeight: 600 },
  },
  shape: {
    borderRadius: 6,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#F1F2F4",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "6px",
          textTransform: "none",
          fontFamily: AUTH_FONT,
          fontWeight: 400,
          boxShadow: "none",
        },
        containedPrimary: {
          backgroundColor: AUTH_COLORS.primary,
          color: AUTH_COLORS.buttonLabel,
          "&:hover": {
            backgroundColor: AUTH_COLORS.primaryHover,
          },
        },
        outlinedPrimary: {
          color: AUTH_COLORS.primary,
          borderColor: AUTH_COLORS.primary,
          backgroundColor: AUTH_COLORS.surface,
          "&:hover": {
            borderColor: AUTH_COLORS.primary,
            backgroundColor: AUTH_COLORS.bgSoft,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: AUTH_COLORS.inputBg,
          fontFamily: AUTH_FONT,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: AUTH_COLORS.border,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#050A44",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: AUTH_COLORS.primary,
            borderWidth: "1px",
          },
          "&.Mui-error .MuiOutlinedInput-notchedOutline, &.Mui-error:hover .MuiOutlinedInput-notchedOutline, &.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              borderColor: AUTH_COLORS.error,
            },
          "&.Mui-disabled": {
            backgroundColor: "#F5F6F8",
          },
        },
        input: {
          fontFamily: AUTH_FONT,
          fontWeight: 400,
          color: AUTH_COLORS.text,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: AUTH_FONT,
          fontWeight: 400,
          color: AUTH_COLORS.textSecondary,
          "&.Mui-focused": {
            color: AUTH_COLORS.primary,
          },
          "&.Mui-error, &.Mui-error.Mui-focused": {
            color: AUTH_COLORS.error,
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontFamily: AUTH_FONT,
          marginLeft: 2,
          "&.Mui-error": {
            color: AUTH_COLORS.error,
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: AUTH_COLORS.surface,
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: AUTH_COLORS.textSecondary,
          minWidth: 40,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
          margin: "2px 8px",
          "&:hover": {
            backgroundColor: AUTH_COLORS.bgSoft,
          },
        },
      },
    },
  },
});
